<template>
  <div class="step" :class="{ 'step_active': active }">
    <div class="step__inner">
      <h3 class="step__title">Заполните данные Заявителя</h3>
      <TextInput :required="true" @setError="errors.name = $event" v-model="form.applicant.name" @update:modelValue="suggestName($event)" text="ФИО Заявителя" name="applicant-name" :validation="(v) => v ? ((v.split(' ').filter(el => el.trim()).length < 2) ? 'Заполните поле' : '') : ''" :options="fullnameSuggest" :blurcondition="form.applicant.name.split(' ').filter(el => el.trim()).length >= 3" />
      <DateInput :validation="birthdateval" :required="true" @setError="errors.birthdate = $event" name="applicant-birthdate" text="Дата рождения Заявителя" :range="false" v-model="form.applicant.birthdate" />
      <SelInput :required="true" text="Документ удостоверяющий личность" name="applicant-doctype" :options="doctypes" v-model="form.applicant.doc.type" />
      <ShortFields>
        <NumberInput :required="true" v-if="dynamicfields.series" mask="####" @setError="errors.series = $event" :filled="(v) => v.length == 4" v-model="form.applicant.doc.series" text="Серия документа" name="applicant-doc-series" />
        <NumberInput :required="true" v-if="dynamicfields.number" mask="######" @setError="errors.number = $event" :filled="(v) => v.length == 6" v-model="form.applicant.doc.number" text="Номер документа" name="applicant-doc-number" />
        <TextInput :maxlength="50" :validation="(v) => (v.length > 50) ? 'Не более 50 символов' : ''" :required="true" v-if="dynamicfields.foreignnumber" @setError="errors.number = $event" v-model="form.applicant.doc.number" text="Номер документа" name="applicant-doc-foreign-number" />
      </ShortFields>
      <ShortFields>
        <NumberInput :forceError="CodeError" :required="true" v-if="dynamicfields.code" mask="###-###" @setError="errors.code = $event" :filled="(v) => v.length == 7" v-model="form.applicant.doc.code" text="Код подразделения " name="applicant-doc-code" />
        <DateInput :required="true" v-if="dynamicfields.releasedate" @setError="errors.releasedate = $event" v-model="form.applicant.doc.releasedate" text="Дата выдачи документа" name="applicant-doc-releasedate" />
      </ShortFields>
      <Btn class="step__next" :disabled="!filled" @click="$store.commit('nextStep')">Далее</Btn>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import TextInput from '@/components/inputs/TextInput.vue';
import Btn from '../Btn.vue';
import DateInput from '../inputs/DateInput.vue';
import SelInput from '../inputs/SelInput.vue';
import ShortFields from '../ShortFields.vue';
import NumberInput from '../inputs/NumberInput.vue';
import nameSuggest from '../../mixins/nameSuggest';
import birthdateValidation from '../../mixins/birthdateValidation';
export default {
  components: { TextInput, DateInput, Btn, SelInput, ShortFields, NumberInput },
  mixins: [nameSuggest, birthdateValidation],
  data: () => ({
    suggestionSuccess: false,
    timer: undefined,
    errors: {},
    doctypes: ['', 'Паспорт гражданина РФ', 'Паспорт иностранного гражданина', 'Иное'],
    dynamicfields: {
      series: false,
      number: false,
      foreignnumber: false,
      code: false,
      releasedate: false
    }
  }),
  props: {
    active: { type: Boolean }
  },
  computed: {
    ...mapState(['form']),
    ...mapGetters(['contractCount']),
    filled() {
      for (let key in this.errors)
        if (this.errors[key]) return false
      if (!this.form.applicant.name || !this.form.applicant.birthdate || !this.form.applicant.doc.type)
        return false
      let required = []
      for (let key in this.dynamicfields)
        if (this.dynamicfields[key])
          if (key == 'foreignnumber')
            required.push('number')
          else
            required.push(key)
      for (let key of required) {
        if (!this.form.applicant.doc[key])
          return false
        if (key == 'code' && this.CodeError)
          return false
      }
      return true
    },
    CodeError() {
      let code = this.form.applicant.doc.code
      if (!this.dynamicfields.code || !code || code.length != 7) return ''
      switch (this.suggestionSuccess) {
        case false:
          return 'Ошибка проверки кода'
        case 'error':
          return 'Неверный код подразделения'
        case 'request_wait':
          return 'Ожидание проверки кода...'
        case 'request_sended':
          return 'Идёт проверка кода...'
        case true:
          return ''
        default:
          return ''
      }
    }
  },
  methods: {
    clearFields() {
      this.form.applicant.doc.number = ''
      this.form.applicant.doc.series = ''
      this.form.applicant.doc.code = ''
      this.form.applicant.doc.releasedate = ''
    },
    setDynamicFields(doctypeindex) {
      switch (doctypeindex) {
        case 1:
          return this.dynamicfields = {
            series: true,
            number: true,
            foreignnumber: false,
            code: true,
            releasedate: true
          }
        case 2:
          return this.dynamicfields = {
            series: false,
            number: false,
            foreignnumber: true,
            code: false,
            releasedate: true
          }
        case 0:
        case 3:
          return this.dynamicfields = {
            series: false,
            number: false,
            foreignnumber: false,
            code: false,
            releasedate: false
          }
      }
    },
    async checkCode(code) {
      this.suggestionSuccess = 'request_sended'
      console.log(code)
      let res = await this.$store.dispatch('suggestCodeLocation', code)
      this.form.applicant.doc.code_info = res
      if (res === false)
        return this.suggestionSuccess = false
      if (res && Array.isArray(res)) {
        if (res.length)
          return this.suggestionSuccess = true
        else
          return this.suggestionSuccess = 'error'
      }
      return this.suggestionSuccess = false
    }
  },
  watch: {
    'form.applicant.doc.type': function (value, old) {
      if (value != old)
        this.clearFields()
      for (let i = 0; i < this.doctypes.length; i++)
        if (value == this.doctypes[i])
          return this.setDynamicFields(i)
    },
    'form.applicant.doc.code': async function (code) {
      if (!code || code.length != 7) return this.suggestionSuccess = false
      if (!this.timer) {
        this.checkCode(code)
        this.timer = setTimeout(() => this.timer = undefined, 500)
      }
      else {
        this.suggestionSuccess = 'request_wait'
        clearTimeout(this.timer)
        this.timer = setTimeout(() => {
          this.checkCode(code)
          this.timer = undefined
        }, 500)
      }
    },
  }
}
</script>

<style lang="sass">

</style>